import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { u as useIsMobile } from '../../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';
import { C as CancelButton } from './CancelButton-BFhcUZXw.js';
import { L as LeaveButton } from './LeaveButton-Feih5mbA.js';

const FooterContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-15z7x6l-0"
})(["display:flex;width:100%;flex-direction:", ";justify-content:flex-end;gap:", ";"], ({
  isMobile
}) => isMobile ? 'column' : 'row', ({
  theme,
  isMobile
}) => isMobile ? theme.spacing.xxsmall.mobile : theme.spacing.xxsmall.default);
const DefaultAbandonmentFooter = ({
  onCancel,
  onLeave,
  ...rest
}) => {
  const isMobile = useIsMobile() || false;
  return /*#__PURE__*/React__default.createElement(FooterContainer, {
    isMobile: isMobile
  }, /*#__PURE__*/React__default.createElement(CancelButton, _extends({
    onCancel: onCancel
  }, rest)), /*#__PURE__*/React__default.createElement(LeaveButton, _extends({
    onLeave: onLeave
  }, rest)));
};

export { DefaultAbandonmentFooter as D };
//# sourceMappingURL=DefaultAbandonmentFooter-BPg205rR.js.map
